import { CARD_MODEL_CLASS_NAME } from 'models/daos/card/constants'
import { CREDENTIAL_CLASS_NAME } from 'models/daos/credential/constants'
import { MAILING_LIST_MODEL_CLASS_NAME } from 'models/daos/mailing-list/constants'
import { SHIPPING_MODEL_CLASS_NAME } from 'models/daos/shipping/constants'

/**
 * A list of instances that are not DAOs.
 * @type {String[]}
 */
const MODEL_FAKE_MODELS = [
  CREDENTIAL_CLASS_NAME,
  CARD_MODEL_CLASS_NAME,
  MAILING_LIST_MODEL_CLASS_NAME,
  SHIPPING_MODEL_CLASS_NAME
]

/**
 * Checks whether the given className is a real instance.
 * @param  {Instance}  instance
 * @returns {boolean}
 */
function isFakeModelUtil (instance) {
  if (!instance) {
    return false
  }
  return MODEL_FAKE_MODELS.includes(instance.className)
}

export {
  isFakeModelUtil
}
